import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NbDialogService } from "@nebular/theme";

import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import { CustomerService } from "../../../services/customer.service";
import { UserService } from "../../../services/user.service";
import { Customer } from "../../../models/customer.model";
import { History } from "../../../models/history.model";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { DialogCustomerComponent } from "../../dialog-customer/dialog-customer.component";
import { DialogHistoryComponent } from "../../dialog-history/dialog-history.component";

@Component({
  selector: "ngx-view-customer",
  styleUrls: ["./view-customer.component.scss"],
  templateUrl: "./view-customer.component.html",
})
export class ViewCustomerComponent implements OnInit {
  @Input() mode?: string = ""; //home / customer
  @Input() customer: Customer;
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "main";
  uid = "";

  constructor(
    public userService: UserService,
    private customerService: CustomerService,
    private dialogService: NbDialogService,
    private router: Router
  ) {
    this.userService.getCurrentUser().subscribe((user) => {
      if (user) {
        this.uid = user.uid;
      } else {
        this.uid = "anonymous";
      }
    });
  }

  ngOnInit() {}

  reply() {
    this.view = "replies";
  }

  closeReply() {
    this.view = "main";
  }

  loadContent(value) {
    this.isMore = value;
  }

  navigateRef(item) {
    if (item.navigateUrl != "") {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.customerService
            .delete(item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.onDelete.emit(item.id);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  edit(item: Customer) {
    let lecBk = new Customer();
    lecBk = clone(item);
    this.dialogService
      .open(DialogCustomerComponent, {
        context: {
          header: "Cập nhật bài viết",
          mode: "edit",
          customer: lecBk,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.customer = value;
          this.onEdit.emit(value);
        }
      });
  }

  createHistory(item: Customer) {
    let lecNew = new History();
    lecNew.customerId = item.id;
    lecNew.fullName = item.fullName;
    lecNew.dobYear = item.dobYear;
    lecNew.issueDate = new Date();

    this.dialogService
      .open(DialogHistoryComponent, {
        context: {
          header: "Tạo trạng thái",
          mode: "new",
          history: lecNew,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
        }
      });
  }

  viewHistory(item) {
    this.router.navigateByUrl("/customer/" + item.id);
  }

  viewProfile(userId) {
    const value = !this.isMore;
    this.loadContent(value);
    // this.dialogService.open(DialogProfileComponent, {
    //   context: {
    //     header: "Thông tin tài khoản",
    //     userId: userId,
    //   },
    //   closeOnBackdropClick: false,
    // });
  }

  //CKEditor
  public editorConfig = {
    toolbar: [["Format", "FontSize", "TextColor", "BGColor", "Image", "Table"]],
    readOnly: true,
    extraPlugins: "autogrow",
    autoGrow_onStartup: true,
    autoGrow_minHeight: 100,
    // autoGrow_maxHeight: 600,
    autoGrow_bottomSpace: 10,
  };
}
